import { createFileRoute } from '@tanstack/react-router'
import ImportStockChanges from 'Administration/components/import/StockChanges/ImportStockChanges'

import AdministrationPage from '../../-administrationPage'
import { Guard } from '../../-guard'

export const Route = createFileRoute('/administration/imports/importstockchanges')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <AdministrationPage>
                <ImportStockChanges />
            </AdministrationPage>
        </Guard>
    ),
})
